export const contactData = [
    {
      id: "location",
      title: "Location",
      icon: "/common/contact_location.svg",
      link: "https://maps.app.goo.gl/wFHHnVRTs9WWcU6M7",
      linkText: "407 Cubes 1, Beacon South Quarter, Sandyford, Dublin 18, Ireland",
    },
    {
      id: "email",
      title: "Email",
      icon: "/common/contact_email.svg",
      link: "mailto:support@qrcodecreator.com",
      linkText: "support@qrcodecreator.com",
    },
  ];